var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportAndUtilityRefuelling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2734.000000, -566.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport-and-Utility/Refuelling",
    transform: "translate(2734.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4998839,0 L18.4998839,32 L0.5,32 L0.5,4 C0.5,1.791 2.29098845,0 4.49997419,0 L4.49997419,0 L18.4998839,0 Z M29.7000116,11 C30.6940052,11 31.5,11.806 31.5,12.8 L31.5,12.8 L31.5,13.6 C31.5,15.172 30.5000065,17 28.5000194,20 L28.5000194,20 L28.5000194,25 C28.5000194,27.209 26.7090309,29 24.5000452,29 C22.2910594,29 20.500071,27.209 20.500071,25 L20.500071,25 L20.500071,14 C22.1570603,14 23.5000516,15.343 23.5000516,17 L23.5000516,17 L23.5000516,25 C23.5000516,25.553 23.9470487,26 24.5000452,26 C25.0530416,26 25.5000387,25.553 25.5000387,25 L25.5000387,25 L25.5000387,11 Z M15.4999032,14 L10.4999355,14 L10.4999355,16 L15.4999032,16 L15.4999032,14 Z M15.4999032,5 L3.49998065,5 L3.49998065,11 L15.4999032,11 L15.4999032,5 Z M29.3118141,1.829 L31.186802,4.171 C29.3028142,5.679 29.2498145,8.967 29.2498145,9 L26.2498339,9 C26.2498339,8.807 26.2848336,4.251 29.3118141,1.829 Z",
    id: 65
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportAndUtilityRefuelling);
export default __webpack_public_path__ + "static/media/transport-and-utility-refuelling.862e2607.svg";
export { ForwardRef as ReactComponent };